import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';
import { isPresent } from '../util/lang';

export const noWhitespace: ValidatorFn = (control: AbstractControl): { [key: string]: boolean } => {
  if (isPresent(Validators.required(control))) return null;

  const isWhitespace = (control.value || '').trim().length === 0;
  return !isWhitespace ? null : { 'whitespace': true };
};